import React, { useEffect, createElement } from 'react';
export function StructuredData() {
  useEffect(() => {
    // Organization Schema
    const organizationSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Stressless Dogs',
      url: 'https://stresslessdogs.nl',
      logo: 'https://stresslessdogs.nl/logo.png',
      description: 'Professioneel hondengedragsadvies en voedingsadvies voor een gezonde, stressvrije hond.',
      email: 'amee@stresslessdogs.nl',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'NL'
      },
      sameAs: []
    };
    // Product Schema
    const productSchema = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: 'Anifit Hondenvoer Proefpakket',
      description: 'Premium natvoer voor honden met 90-99% vleesgehalte, Zweeds kwaliteitsvlees zonder conserveringsmiddelen of smaakversterkers.',
      brand: {
        '@type': 'Brand',
        name: 'Anifit'
      },
      offers: {
        '@type': 'Offer',
        url: 'https://www.anifit.com/content/dierenvoeding/shop/shop/article/284458/proefpakket_hond_400g_1_set_met_verschillende_soorten_natvoer_vlokken_en_testpakketten_?new_client_country=NL&category=62183&refconsultant=487050',
        priceCurrency: 'EUR',
        availability: 'https://schema.org/InStock',
        priceValidUntil: '2025-12-31',
        seller: {
          '@type': 'Organization',
          name: 'Stressless Dogs'
        }
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '3'
      },
      review: [{
        '@type': 'Review',
        author: {
          '@type': 'Person',
          name: 'Amber'
        },
        reviewRating: {
          '@type': 'Rating',
          ratingValue: '5'
        },
        reviewBody: 'De constante jeuk van mijn hond is volledig verdwenen. Binnen 3 weken zag ik al verschil. Had ik dit maar eerder geweten.'
      }]
    };
    // FAQ Schema
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [{
        '@type': 'Question',
        name: 'Anifit is duurder dan mijn huidige voer',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Klopt - per blik. Maar reken even mee: Een blik van 810g bevat ~750g vers vlees. Regulier natvoer met 40% vlees: je hebt bijna 2 blikken nodig voor dezelfde hoeveelheid. Minder dierenartskosten door betere gezondheid. Je hond heeft minder nodig omdat alles wordt opgenomen. Per gram vlees is Anifit vaak goedkoper dan je denkt.'
        }
      }, {
        '@type': 'Question',
        name: 'Mijn hond is kieskeurig, eet hij dit wel?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Honden houden van nature van vers vlees. Als je hond kieskeurig is, komt dat vaak door gewenning aan kunstmatige smaakversterkers of een verstoorde darmflora. Anifit heeft geen smaakversterkers nodig - het hoge vleesgehalte en natuurlijke vet zijn aantrekkelijk genoeg. Na een korte gewenningsperiode gaan de meeste honden er direct op af.'
        }
      }, {
        '@type': 'Question',
        name: 'Ik ben bang voor problemen tijdens de overstap',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Begrijpelijk. Daarom begeleiden wij je persoonlijk met een geleidelijke overgang in 10 dagen. Tijdelijke diarree of winderigheid is normaal - teken van ontgifting. Power-Darm versnelt het darmherstel. De meeste honden wennen binnen 10 dagen probleemloos. Vragen? Mail ons direct: amee@stresslessdogs.nl'
        }
      }, {
        '@type': 'Question',
        name: 'Is het echt zoveel beter dan ander premium natvoer?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Check het etiket van je huidige voer: Staat er exact welk percentage van welk ingrediënt erin zit? Is het vlees goedgekeurd voor menselijke consumptie? Staan er conserveringsmiddelen of smaakversterkers in? Wat is de herkomst van het vlees? Anifit scoort op al deze punten. Vergelijk zelf - de verschillen zijn vaak groter dan je denkt.'
        }
      }]
    };
    // Offer Schema for discount
    const offerSchema = {
      '@context': 'https://schema.org',
      '@type': 'Offer',
      name: '10% Korting op Anifit Hondenvoer',
      description: "Gebruik code 'stressless' voor 10% korting op je eerste bestelling + gratis persoonlijk voedingsadvies",
      priceSpecification: {
        '@type': 'PriceSpecification',
        price: '10',
        priceCurrency: 'EUR',
        valueAddedTaxIncluded: true
      },
      eligibleQuantity: {
        '@type': 'QuantitativeValue',
        value: 1
      },
      seller: {
        '@type': 'Organization',
        name: 'Stressless Dogs'
      }
    };
    // Insert all schemas
    const schemas = [organizationSchema, productSchema, faqSchema, offerSchema];
    schemas.forEach((schema, index) => {
      const scriptId = `structured-data-${index}`;
      let script = document.getElementById(scriptId);
      if (!script) {
        script = document.createElement('script');
        script.id = scriptId;
        script.type = 'application/ld+json';
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    });
    // Cleanup function
    return () => {
      schemas.forEach((_, index) => {
        const script = document.getElementById(`structured-data-${index}`);
        if (script) {
          script.remove();
        }
      });
    };
  }, []);
  return null;
}